<script>
  import { onMount } from "svelte";
  import {
    panelController,
    modalS,
    updateService,
    enviarNotificacion,
    viewMesas,
  } from "../../../stores/service";
  import { Toast } from "bootstrap";
  import { createNewDate } from "../../../Controller/APIs/date";
  import { configListMesa } from "../../../Controller/apps/paneListMesas/main";
  import { modelValid } from "../../../Models/modelSystemG";
  import MesasQR from "./mesasQR.svelte";
  import AdSlot from "../../../components/ads/AdSlot.svelte";
  import { acceptsNew } from "../../../Controller/apps/paneListMesas/acceptingTables";

  let validacion = true;
  let audio = new Audio("components_dash/not.mp3");
  let viewConfigMesa = {
    realtime: true,
    mesasActivas: false,
  };
  let activeTab = "live";

  let configListMes = new configListMesa();
  mainConfig()
  function mainConfig() {
    viewConfigMesa = configListMes.listMesasConfig.settings;
    realtime()
    
  }

  function realtime() {

    configListMes.updPaneListMesassettings(viewConfigMesa);

    if (!viewConfigMesa.realtime) {
      return;
    }

    if ($viewMesas.realtime) {
      return
    }

    modelValid({
      doc: "readDocRealTime",
      data: { collection: "service", id: $panelController.firebase.docs[0].id },
    });
    $viewMesas.realtime = true;
  }
  $: accepting = acceptsNew($panelController.service);

  async function toggleAccepting() {
    $panelController.service.service.acceptingNew = !accepting;
    await updateService();
  }

  function mesasActivas() {
    configListMes.updPaneListMesassettings(viewConfigMesa);
  }

  function deletenot(index) {
    clearTimeout(
      $panelController.notificaciones.ToastList[index].data.timeoutID,
    );

    $panelController.notificaciones.ToastList[index].status = false;

    if ($panelController.notificaciones.timeoutID.length > 0) {
      createToast($panelController.notificaciones.timeoutID[0]);
      $panelController.notificaciones.timeoutID.splice(0, 1);
    }
  }

  export const mostrarMensaje = (index) => {
    clearTimeout(
      $panelController.notificaciones.ToastList[index].data.timeoutID,
    );

    $panelController.notificaciones.ToastList[index].status = true;
    audio.play();
    new Toast(
      $panelController.notificaciones.ToastList[index].data.show,
    ).show();
    $panelController.notificaciones.ToastList[index].data.timeoutID =
      setTimeout(() => {
        deletenot(index);
      }, 4 * 1000);
  };

  function createToast(item) {
    let createToaS = {
      index: 0,
      status: false,
    };

    $panelController.notificaciones.ToastList.forEach((element, index) => {
      if (element.status == false && !createToaS.status) {
        createToaS.status = true;
        createToaS.index = index;
      }
    });

    if (createToaS.status) {
      $panelController.notificaciones.ToastList[createToaS.index].status = true;
      $panelController.notificaciones.ToastList[createToaS.index].data.title =
        item.title;
      $panelController.notificaciones.ToastList[createToaS.index].data.body =
        item.body;
      $panelController.notificaciones.ToastList[createToaS.index].data.img =
        item.img;
      $panelController.notificaciones.ToastList[createToaS.index].data.time =
        item.time;
      $panelController.notificaciones.ToastList[
        createToaS.index
      ].data.timeoutID = setTimeout(() => {
        mostrarMensaje(createToaS.index);
      }, createToaS.index * 1000);
    } else {
      $panelController.notificaciones.timeoutID.push(item);
    }
  }

  async function creadeintervalo(index) {
    $viewMesas.mesaData[index].status = true;
    $viewMesas.mesaData[index].time = await calcularDiferenciaDeTiempo(
      $panelController.service.service.mesasService[index].service.date,
    );
    createToast({
      title: "Nuevo pedido",
      img: $panelController.service.service.mesasService[index].dataUser.status
        ? $panelController.service.service.mesasService[index].dataUser.photoURL
        : $panelController.icons.ico,
      body: $panelController.service.service.mesasService[index].dataUser.status
        ? `Mesa ${index + 1} : ${
            $panelController.service.service.mesasService[index].dataUser
              .displayName
          }`
        : `Mesa ${index + 1} : Cliente`,
      time: $panelController.service.service.mesasService[index].service.date
        .toDate()
        .toLocaleTimeString(),
    });

    $viewMesas.mesaData[index].intervalo = setInterval(
      () => {
        $viewMesas.mesaData[index].time++;
      },

      1000,
    );
  }

  onMount(async () => {
    if (!$viewMesas.status) {
      $panelController.service.service.mesasService.forEach((element) => {
        $viewMesas.mesaData.push({
          intervalo: null,
          time: "",
          status: false,
          cuenta: false,
        });
      });

      $viewMesas.status = true;
    }
  });


  let i = 0;
  let data = {};
  let intervalos = {};
  let dataList = [];

  async function opcMesa(index) {
    /* eliminar */
    $modalS.reset();
    $modalS.info.title = `Aviso: Mesa ${index + 1}`;

    $modalS.controllers.btnClose = true;

    $modalS.info.body = "Mesa " + (index + 1);
    if (!$panelController.service.service.mesasService[index].status) {
      /* BTN ACTIVAR MESA */
      $modalS.controllers.btn[0].status = false;
      $modalS.controllers.btn[0].text = `Activar mesa ${index + 1}`;

      $modalS.controllers.btn[1].status = false;
      $modalS.info.body = "No esta activa ";
    }
    if ($panelController.service.service.mesasService[index].status) {
      /* rEINICIAR MESA */
      $modalS.controllers.btn[0].status = false;
      $modalS.controllers.btn[1].status = true;
      $modalS.controllers.btn[1].text = `Finalizar`;

      if (
        $panelController.service.service.mesasService[index].dataUser.status
      ) {
        $modalS.info.body = `Esta activa con el usuario ${$panelController.service.service.mesasService[index].dataUser.displayName}`;
      } else {
        $modalS.info.body = `Esta activa`;
      }
    }

    let modal = await $modalS.mostrar();
    if (modal) {
    } else {
      ReiniciarMesa(index);
    }
  }

  async function calcularDiferenciaDeTiempo(momentoInicial) {
    let date = await createNewDate("America/Mexico_City");
    const timestamp = momentoInicial;
    const fecha = new Date(
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1e6,
    );

    const diferencia = date.currentDate - fecha;
    const segundosPasados = Math.floor(diferencia / 1000);
    return segundosPasados;
  }

  function tem(time) {
    let minutos = Math.floor(time / 60);
    let segundos = time % 60;
    if (minutos < 1) {
      if (segundos < 10) {
        return `00:0${segundos}`;
      } else {
        return `00:${segundos}`;
      }
    } else {
      if (minutos < 10) {
        if (segundos < 10) {
          return `0${minutos}:0${segundos}`;
        } else {
          return `0${minutos}:${segundos}`;
        }
      } else {
        if (segundos < 10) {
          return `${minutos}:0${segundos}`;
        } else {
          return `${minutos}:${segundos}`;
        }
      }
    }
  }

  function endService(index) {
    clearInterval($viewMesas.mesaData[index].intervalo);
    $viewMesas.mesaData[index].time = "";
    $viewMesas.mesaData[index].status = false;
  }

  $: {
    if ($viewMesas.mesaData.length > 0) {
      $panelController.service.service.mesasService.forEach((item, index) => {
        if (
          item.service.status &&
          $viewMesas.mesaData[index].status == false &&
          $panelController.service.service.mesasService[index].service.date !==
            ""
        ) {
          creadeintervalo(index);
          IniciarAlerta(index + 1);
        }

        if (item.service.status == false && $viewMesas.mesaData[index].status) {
          endService(index);
        }

        if (
          item.cuenta.status &&
          !$viewMesas.mesaData[index].cuenta &&
          $panelController.service.service.mesasService[index].service.date !==
            ""
        ) {
          IniciarAlerta(index + 1);
          $viewMesas.mesaData[index].cuenta = true;
          createToast({
            title: "Cuenta",
            img: $panelController.service.service.mesasService[index].dataUser
              .status
              ? $panelController.service.service.mesasService[index].dataUser
                  .photoURL
              : $panelController.icons.ico,
            body: $panelController.service.service.mesasService[index].dataUser
              .status
              ? `Mesa ${index + 1} : ${
                  $panelController.service.service.mesasService[index].dataUser
                    .displayName
                }`
              : `Mesa ${index + 1} : Cliente`,
            time: $panelController.service.service.mesasService[
              index
            ].service.date
              .toDate()
              .toLocaleTimeString(),
          });
        }
      });
    }
  }

  function ReiniciarMesa(index) {
    /* update */
    $panelController.service.service.mesasService[index] = {
      status: false,
      service: {
        n: 0,
        date: "",
        status: false,
      },
      dataUser: { status: false, displayName: "", photoURL: "" },
      cuenta: {
        n: 0,
        date: "",
        status: false,
      },
    };
    updateService();
  }

  function IniciarAlerta(n) {
    if (window.AndroidBridge) {
      window.AndroidBridge.alertaMesaActiva(n);
    }
  }
</script>

<svelte:head>
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link href="https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600;9..144,700&family=DM+Sans:wght@400;500;600;700&display=swap" rel="stylesheet">
</svelte:head>

<!-- Dos campos numéricos -->

<div class="mesas-panel">
  {#if $viewMesas.status}
    {#if $viewMesas.status}
      <div class="mesas-card">
        <div class="mesas-card-body">
          {#if $panelController.service.service.mesasService.length > 0}
            <div class="mesas-identity">
              {#if $panelController.service.ico}
                <img
                  class="mesas-identity-logo"
                  src={$panelController.service.ico}
                  alt=""
                />
              {/if}
              <span class="mesas-identity-name">{$panelController.service.name}</span>
            </div>

            <div class="mesas-toolbar">
              <div class="mesas-toolbar-title">
                <h2 class="titl">Mesas</h2>
                {#if viewConfigMesa.realtime}
                  <span class="mesas-live" class:is-hidden={activeTab !== "live"}><i class="mesas-live-pip" />en vivo</span>
                {/if}
              </div>

              <div class="mesas-tabs" role="tablist" aria-label="Vista de mesas">
                <button
                  type="button"
                  class="mesas-tab {activeTab === 'live' ? 'is-active' : ''}"
                  role="tab"
                  aria-selected={activeTab === "live"}
                  on:click={() => (activeTab = "live")}
                >
                  Vista en vivo
                </button>
                <button
                  type="button"
                  class="mesas-tab {activeTab === 'qr' ? 'is-active' : ''}"
                  role="tab"
                  aria-selected={activeTab === "qr"}
                  on:click={() => (activeTab = "qr")}
                >
                  Códigos QR
                </button>
              </div>

                <nav id="navbar-example" class="mesas-toolbar-switches">
                  <label class="mesas-switch" class:is-hidden={activeTab !== "live"}>
                    <input
                      type="checkbox"
                      role="switch"
                      id="mesas-switch-realtime"
                      bind:checked={viewConfigMesa.realtime}
                      on:change={() => realtime()}
                    />
                    <span class="mesas-switch-track" aria-hidden="true" />
                    <span class="mesas-switch-label">Panel en tiempo real</span>
                  </label>
                  <label class="mesas-switch" class:is-hidden={activeTab !== "live"}>
                    <input
                      type="checkbox"
                      role="switch"
                      id="mesas-switch-activas"
                      bind:checked={viewConfigMesa.mesasActivas}
                      on:change={() => mesasActivas()}
                    />
                    <span class="mesas-switch-track" aria-hidden="true" />
                    <span class="mesas-switch-label">Solo mesas activas</span>
                  </label>
                  <label class="mesas-switch">
                    <input
                      type="checkbox"
                      role="switch"
                      id="mesas-switch-accepting"
                      checked={accepting}
                      on:change={toggleAccepting}
                    />
                    <span class="mesas-switch-track" aria-hidden="true" />
                    <span class="mesas-switch-label">Recibir mesas nuevas</span>
                  </label>
                </nav>
            </div>

            {#if !accepting}
              <p class="mesas-closed" role="status">
                Cerrado a mesas nuevas. Las mesas activas siguen su servicio.
              </p>
            {/if}

            {#if activeTab === "live"}
              <div class="mesas-grid">
                {#each $panelController.service.service.mesasService as m, index}
                  {#if !viewConfigMesa.mesasActivas || m.status}
                    <a
                      class="mesa-tile
                        {m.status ? 'is-open' : 'is-idle'}
                        {m.service.status ? 'is-calling' : ''}"
                      on:click={() => opcMesa(index)}
                    >
                      <span class="mesa-tile-accent" />
                      <div class="mesa-tile-content">
                        <span class="mesa-tile-motif" aria-hidden="true">
                          <span class="mesa-tile-motif-chair top" />
                          <span class="mesa-tile-motif-chair bottom" />
                          <span class="mesa-tile-motif-chair left" />
                          <span class="mesa-tile-motif-chair right" />
                        </span>
                        <span class="mesa-tile-number">{index + 1}</span>
                        <span class="mesa-tile-status">
                          {#if m.service.status}
                            Llamando{#if $viewMesas.mesaData[index].status}
                              · {tem($viewMesas.mesaData[index].time)}{/if}
                          {:else if m.status}
                            En servicio{#if $viewMesas.mesaData[index].status}
                              · {tem($viewMesas.mesaData[index].time)}{/if}
                          {:else}
                            Libre
                          {/if}
                        </span>

                        {#if m.status}
                          <div class="mesa-tile-client">
                            <img
                              class="mesa-tile-avatar"
                              src={m.dataUser.status
                                ? m.dataUser.photoURL
                                : $panelController.icons.ico}
                              alt=""
                            />
                            <span
                              >{m.dataUser.status
                                ? m.dataUser.displayName
                                : "Cliente"}</span
                            >
                          </div>
                        {/if}

                        {#if m.cuenta.status}
                          <span class="mesa-cuenta-pill">Cuenta</span>
                        {/if}
                      </div>
                    </a>
                  {/if}
                {/each}
              </div>
            {:else}
              <MesasQR />
            {/if}
          {/if}
        </div>
      </div>
    {/if}
  {/if}
</div>

<div class="text-center mt-3">
  <AdSlot />
</div>
<br />

<style>
  .modal {
    display: block;
  }

  .mesas-panel {
    --cream: #fbf6ea;
    --cream-deep: #f3ead5;
    --ink: #2a2a1c;
    --ink-soft: #57543f;
    --ink-faint: #83805f;
    --olive-900: #2c3320;
    --olive-700: #4c5a34;
    --olive-500: #7e934e;
    --olive-300: #a7be78;
    --olive-200: #cbdaa4;
    --olive-100: #e4ebce;
    --yellow-600: #c99a1e;
    --yellow-500: #eec13b;
    --yellow-100: #fbeec4;
    --coral-700: #b14b2c;
    --coral-500: #e2703f;
    --coral-300: #efa07c;
    --coral-100: #f8d9c6;
    font-family: "DM Sans", system-ui, -apple-system, sans-serif;
    color: var(--ink);
    padding: 0.5rem 0 1.5rem;
  }

  .mesas-card {
    background: var(--cream);
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 12px 32px rgba(44, 51, 32, 0.1);
  }

  .mesas-card-body {
    padding: 1.75rem;
  }

  .mesas-identity {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1.25rem;
  }

  .mesas-identity-logo {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    object-fit: cover;
  }

  .mesas-identity-name {
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--ink-soft);
  }

  .titl {
    font-family: "Fraunces", ui-serif, Georgia, serif;
    font-weight: 600;
    font-size: 1.6rem;
    color: var(--olive-900);
    margin: 0;
  }

  .mesas-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 1rem 1.5rem;
    margin-bottom: 2rem;
  }

  .mesas-tabs {
    display: flex;
    gap: 0.25rem;
    background: var(--olive-100);
    border-radius: 10px;
    padding: 3px;
    width: fit-content;
  }

  .mesas-tab {
    font-family: "DM Sans", system-ui, -apple-system, sans-serif;
    font-weight: 600;
    font-size: 0.85rem;
    color: var(--ink-faint);
    background: transparent;
    border: none;
    border-radius: 8px;
    padding: 0.4rem 0.9rem;
    cursor: pointer;
    transition:
      background 0.15s ease,
      color 0.15s ease;
  }

  .mesas-tab.is-active {
    background: var(--cream);
    color: var(--olive-900);
    box-shadow: 0 1px 3px rgba(44, 51, 32, 0.15);
  }

  .mesas-toolbar-title {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .mesas-live {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 0.78rem;
    font-weight: 700;
    color: var(--coral-700);
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .mesas-live-pip {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--coral-500);
    animation: mesasLivePulse 1.6s ease-in-out infinite;
  }

  @keyframes mesasLivePulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.35;
    }
  }

  .mesas-closed {
    margin: -1rem 0 1.25rem;
    padding: 0.5rem 0.85rem;
    border-radius: 10px;
    background: var(--coral-100);
    color: var(--coral-700);
    font-size: 0.85rem;
    font-weight: 600;
  }

  .is-hidden {
    visibility: hidden;
  }

  .mesas-toolbar-switches {
    display: flex;
    flex-wrap: wrap;
    gap: 1.25rem;
  }

  .mesas-switch {
    display: inline-flex;
    align-items: center;
    gap: 0.55rem;
    cursor: pointer;
  }

  .mesas-switch input {
    position: absolute;
    opacity: 0;
    width: 1px;
    height: 1px;
  }

  .mesas-switch-track {
    position: relative;
    width: 34px;
    height: 20px;
    border-radius: 999px;
    background: var(--olive-100);
    transition: background 0.15s ease;
    flex: none;
  }

  .mesas-switch-track::after {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: var(--cream);
    box-shadow: 0 1px 3px rgba(44, 51, 32, 0.35);
    transition: transform 0.15s ease;
  }

  .mesas-switch input:checked + .mesas-switch-track {
    background: var(--olive-500);
  }

  .mesas-switch input:checked + .mesas-switch-track::after {
    transform: translateX(14px);
  }

  .mesas-switch input:focus-visible + .mesas-switch-track {
    outline: 2px solid var(--coral-500);
    outline-offset: 2px;
  }

  .mesas-switch-label {
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--ink-soft);
  }

  .mesas-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
    gap: 1rem;
  }

  .mesa-tile {
    position: relative;
    display: grid;
    grid-template-columns: 5px 1fr;
    background: var(--olive-100);
    border: 1px solid rgba(44, 51, 32, 0.08);
    border-radius: 14px;
    overflow: hidden;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    transition:
      transform 0.15s ease,
      box-shadow 0.15s ease,
      background 0.2s ease;
  }

  .mesa-tile:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 18px rgba(44, 51, 32, 0.12);
  }

  .mesa-tile-accent {
    background: var(--olive-300);
  }

  .mesa-tile-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.3rem;
    padding: 0.9rem 0.9rem 0.85rem;
  }

  /* Motivo decorativo (mesa + sillas) de fondo, solo textura - el estado real
     lo comunican la barra de acento y el texto, nunca este dibujo. */
  .mesa-tile-motif {
    position: absolute;
    right: 6px;
    bottom: 4px;
    width: 42px;
    height: 42px;
    opacity: 0.16;
    pointer-events: none;
  }

  .mesa-tile-motif::before {
    content: "";
    position: absolute;
    inset: 7px;
    border-radius: 6px;
    border: 2px solid var(--ink);
  }

  .mesa-tile-motif-chair {
    position: absolute;
    width: 7px;
    height: 7px;
    border-radius: 2px;
    background: var(--ink);
  }

  .mesa-tile-motif-chair.top {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .mesa-tile-motif-chair.bottom {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .mesa-tile-motif-chair.left {
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .mesa-tile-motif-chair.right {
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .mesa-tile-number {
    font-family: "Fraunces", ui-serif, Georgia, serif;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 1;
    color: var(--ink);
  }

  .mesa-tile-status {
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: var(--ink-faint);
  }

  .mesa-tile-client {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.78rem;
    color: var(--ink-soft);
    max-width: 100%;
  }

  .mesa-tile-client span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mesa-tile-avatar {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    object-fit: cover;
    flex: none;
    border: 1px solid var(--cream);
  }

  /* Mesa en servicio, sin llamados pendientes */
  .mesa-tile.is-open {
    background: var(--olive-200);
  }

  .mesa-tile.is-open .mesa-tile-accent {
    background: var(--olive-700);
  }

  .mesa-tile.is-open .mesa-tile-status {
    color: var(--ink);
  }

  /* Mesa llamando al equipo de servicio */
  .mesa-tile.is-calling {
    background: var(--coral-100);
  }

  .mesa-tile.is-calling .mesa-tile-accent {
    background: var(--coral-700);
  }

  .mesa-tile.is-calling .mesa-tile-status {
    color: var(--coral-700);
  }

  /* Mesa solicitando la cuenta */
  .mesa-cuenta-pill {
    align-self: flex-start;
    background: var(--yellow-100);
    color: var(--yellow-600);
    border: 1px solid var(--yellow-600);
    border-radius: 999px;
    padding: 1px 8px;
    font-size: 0.68rem;
    font-weight: 700;
  }
</style>
